<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="padding-top:100px;">About The Author</h1>
<p>Kirk Henderson is an author, screenwriter, art director, and filmmaker. He has written extensively about film and film music, with articles published in a variety of film magazines including <em>Music from the Movies</em>, <em>Film Score Monthly</em>, and <em>Little Shoppe of Horrors</em>. He has created concepts and/or art directed for Lucasfilm, Industrial Light &amp; Magic, and San Francisco’s once vanguard of animation, Colossal Pictures. Mr. Henderson has won awards for his short films, including <em>The Visage</em>, currently re-licensed by Shorts Intl. <em>Hollywood v. Beauty and the Synchronicity of the Six</em> is his first book.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?2fa4a6ba